import React, { useState } from 'react';
import { supabase } from './supabaseClient';
import { logAuthEvent } from './auditLog';
import logoUrl from './assets/storsafe-logo.png';

const eyeBtnStyle: React.CSSProperties = {
  position: 'absolute',
  right: 12,
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  color: '#64748b',
  padding: 4,
  display: 'flex',
  alignItems: 'center',
};

export default function ResetPassword() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (newPassword.length < 8) {
      setError('La contraseña debe tener al menos 8 caracteres.');
      return;
    }
    if (!/[A-Z]/.test(newPassword)) {
      setError('La contraseña debe tener al menos una letra mayúscula.');
      return;
    }
    if (!/[0-9]/.test(newPassword)) {
      setError('La contraseña debe tener al menos un número.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Las contraseñas no coinciden.');
      return;
    }
    setLoading(true);
    const { error: updateError } = await supabase.auth.updateUser({ password: newPassword });
    if (updateError) {
      setError('No se pudo actualizar la contraseña. El enlace puede haber expirado.');
    } else {
      logAuthEvent('password_changed');
      setSuccess(true);
      setTimeout(() => { window.location.href = '/'; }, 3000);
    }
    setLoading(false);
  };

  return (
    <div className="login-root">
      <div className="login-card">
        <div className="login-logo">
          <img src={logoUrl} alt="StorSafe" className="login-logo-img" />
        </div>
        <p className="login-tagline">Restablecer contraseña</p>

        {success ? (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <p style={{ color: '#2FBF71', fontSize: '0.95rem', marginBottom: 8 }}>
              Contraseña actualizada correctamente
            </p>
            <p style={{ color: '#64748b', fontSize: '0.83rem' }}>
              Redirigiendo al inicio de sesión…
            </p>
          </div>
        ) : (
          <form className="login-form" onSubmit={handleSubmit}>
            <div className="field-group">
              <label htmlFor="new-pass">Nueva contraseña</label>
              <div className="input-wrapper">
                <LockIcon />
                <input
                  id="new-pass"
                  type={showNew ? 'text' : 'password'}
                  placeholder="Mínimo 8 caracteres"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  minLength={8}
                  required
                  disabled={loading}
                  style={{ paddingRight: 44 }}
                />
                <button type="button" onClick={() => setShowNew(v => !v)} style={eyeBtnStyle} tabIndex={-1}>
                  {showNew ? <EyeOffIcon /> : <EyeOnIcon />}
                </button>
              </div>
            </div>

            <div className="field-group">
              <label htmlFor="confirm-pass">Confirmar contraseña</label>
              <div className="input-wrapper">
                <LockIcon />
                <input
                  id="confirm-pass"
                  type={showConfirm ? 'text' : 'password'}
                  placeholder="Repite la contraseña"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  disabled={loading}
                  style={{ paddingRight: 44 }}
                />
                <button type="button" onClick={() => setShowConfirm(v => !v)} style={eyeBtnStyle} tabIndex={-1}>
                  {showConfirm ? <EyeOffIcon /> : <EyeOnIcon />}
                </button>
              </div>
            </div>

            {error && <p className="login-error">{error}</p>}

            <button
              type="submit"
              className="btn-login"
              disabled={loading || newPassword.length < 8 || newPassword !== confirmPassword}
            >
              {loading ? <span className="btn-spinner" /> : 'Actualizar contraseña'}
            </button>
          </form>
        )}

        <div style={{ marginTop: 20, textAlign: 'center' }}>
          <p style={{ fontSize: '0.72rem', color: '#475569', margin: 0 }}>© 2026 StorSafe · AndeanSoft SAS</p>
        </div>
      </div>
    </div>
  );
}

function LockIcon() {
  return (
    <svg className="input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0110 0v4" />
    </svg>
  );
}
function EyeOnIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}
function EyeOffIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
  );
}
